"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const messagesMap_1 = __importDefault(require("../messagesMap"));
const isNewable_1 = __importDefault(require("../validation/isNewable"));
const getModuleMetadata_1 = require("../metadata/getModuleMetadata");
function unbindModule(Module) {
    return __awaiter(this, void 0, void 0, function* () {
        const metadata = (0, getModuleMetadata_1.getModuleMetadata)(Module);
        const newableModulesImported = metadata.imports.filter((item) => (0, isNewable_1.default)(item));
        if (metadata.isBinded) {
            yield metadata.container.unbindAllAsync();
            metadata.isBinded = false;
        }
        for (const item of newableModulesImported) {
            const isModule = !!Reflect.getMetadata(constants_1.IS_MODULE_KEY, item.prototype);
            if (isModule) {
                yield unbindModule(item);
            }
            else {
                console.warn(messagesMap_1.default.notAModuleUnbinded(item.name));
            }
        }
    });
}
exports.default = unbindModule;
